// UAT Credentials - Zmall
export const Dashen_Constants = {
  fabric_app_ID: "2ca1a64b-291b-877b-6180-ce4b33e79065",
  short_code: "521877",
  appSecret: "9298c34a5ba913172202dd75bb98b1e8960fdd642885cd52",
  publicKey:
    "-----BEGIN PUBLIC KEY-----\nMIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEApuZRqEEFOcV6I38BSvtI\nZV1hqoII+Aoj4qOt/h6q+iLvGZep1zefBMAbk3QhTOH2szRqXI8Q98b8xD/PAsY1\n861w0fl3q3mzsY8Ko8NMoIAfw2s25UiXsYUsAI30zEIAcVeJUVqFq1rhFlfFzlgU\nypgtigsMF8mhhH0KJgQaV/CFcLWSABmhgzczs9isEjVfh+5zamO8ex7o0WPSyxNO\nbZTCQonpcVDqexeX5n8k42zvwd2ueQcEWf8naEsqFQXjMAh0decnPefUENFJEkQo\nSFyl16wHQ9G81DfFVOLSTO1nsuQ/en83MZyCnNLHmFKWjI6oxVBhpKYQvvTu2jOn\neQ5y+5Tvo1HODsjR3z5n5Q0TaaaZDpar/XVnB60bXYaZAOpmuTM6lnLQnSrBvml8\nTy2AtimXkTJtut/YrK9BWteoJdp1s3waa0zkDrs3EfMjhcYaT6D7yBCksXMjzrnT\nsBEc/gRnbgH2sst5P1/VDyucxAOtXIXzjtw0ZXdC73DOEgmCxK4CPX7OVmT4YTm+\nLOAuCs30AUT8r4TTL2BmRz1tqI5LGcXlg3KyIBmgy6iQXYWReD/O/6KIWbRpGkNv\nk/xdFn4n4WmWP+EEYghM/rp/c3L6nw81lLTIV1JVe1z21JkELbQqoT9rU8MBKqUE\nBV9cX5BmLhV+K8sbzEEju/UCAwEAAQ==\n-----END PUBLIC KEY-----\n",
  MINI_APP_CODE: "360133",
  MERCHANT_ID: "20882",
  BASE_URL:"https://sau.eaglelionsystems.com/v1.0/chatbirrapi/miniapps/apps/getfabrictoken",
};

// APIs
// -------
// Getting fabric token:

// curl --location 'https://dev.eaglelionsystems.com/v1.0/chatbirrapi/miniapps/apps/getfarictoken' \
// --header 'x-api-key: <app_secret>' \
// --data '{
//     "appcode" : "<mini_app_code>",
//     "stage" : "uat",
//     "customeridentifier" : "<customer_identifier_from_superapp>"
// }'
